import React, { Fragment, lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import AuthGuard from './components/Auth/AuthGuard';
import GuestGuard from './components/Auth/GuestGuard';
import RoleGuard from './components/Auth/RoleGuard';
import Loader from './components/Loader/Loader';
import { BASE_URL } from './config/constant';
import AdminLayout from './layouts/AdminLayout';
import AdminProjectLayout from './layouts/AdminProjectLayout';
export const renderRoutes = (routes = []) => (
    <Suspense fallback={<Loader />}>
        <Switch>
            {routes.map((route, i) => {
                const Guard = route.guard || Fragment;
                const Layout = route.layout || Fragment;
                const Component = route.component;
                // console.log(route);
                return (
                    <Route
                        key={i}
                        path={route.path}
                        exact={route.exact}
                        render={(props) => (
                            <Guard>
                                {route.title ? (
                                    <RoleGuard title={route?.title}>
                                        <Layout>{route.routes ? renderRoutes(route.routes) : <Component {...props} />}</Layout>
                                    </RoleGuard>
                                ) : (
                                    <Layout>{route.routes ? renderRoutes(route.routes) : <Component {...props} />}</Layout>
                                )}
                            </Guard>
                            // <Guard>
                            //     <Layout>{route.routes ? renderRoutes(route.routes) : <Component {...props} />}</Layout>
                            // </Guard>
                        )}
                    />
                );
            })}
        </Switch>
    </Suspense>
);

const routes = [
    {
        exact: true,
        guard: GuestGuard,
        path: '/auth/signin',
        component: lazy(() => import('./views/auth/signin/SignIn1'))
    },
    {
        exact: true,
        guard: GuestGuard,
        path: '/auth/signin',
        component: lazy(() => import('./views/auth/signin/SignIn1'))
    },
    {
        exact: true,
        guard: GuestGuard,
        path: '/auth/signup',
        component: lazy(() => import('./views/auth/signup/SignUp1'))
    },
    {
        exact: true,
        guard: GuestGuard,
        path: '/termsAndConditions',
        component: lazy(() => import('./views/StaticPage/TermsAndConditions'))
    },
    {
        exact: true,
        guard: GuestGuard,
        path: '/privacyPolicy',
        component: lazy(() => import('./views/StaticPage/PrivacyPolicy'))
    },
    {
        exact: true,
        guard: GuestGuard,
        path: '/paymentConfirmation',
        component: lazy(() => import('./views/StaticPage/SuccessPage'))
    },

    {
        path: '*',
        layout: AdminLayout,
        guard: AuthGuard,
        routes: [
            {
                exact: true,
                path: '/app/welcome',
                component: lazy(() => import('./views/welcome'))
            },

            {
                title: 'user',
                exact: true,
                path: '/app/user',
                component: lazy(() => import('./views/Users/Users'))
            },
            {
                title: 'dashboard',
                exact: true,
                path: '/app/dashboard',
                component: lazy(() => import('./views/DashBoard/DashBoard'))
            },
            {
                title: 'order',
                exact: true,
                path: '/app/order',
                component: lazy(() => import('./views/Order/Order'))
            },
            {
                title: 'coupons',
                exact: true,
                path: '/app/coupons',
                component: lazy(() => import('./views/Coupons/Coupons'))
            },
            {
                title: 'transaction',
                exact: true,
                path: '/app/transaction',
                component: lazy(() => import('./views/Transaction/Transaction'))
            },
            {
                title: 'messages',
                exact: true,
                path: '/app/messages',
                component: lazy(() => import('./views/Messages/Message'))
            },

            // {
            //     title: 'report',
            //     exact: true,
            //     path: '/app/report',
            //     component: lazy(() => import('./views/report/Report'))
            // },
            // {
            //     title: 'errorReport',
            //     exact: true,
            //     path: '/app/errorReport',
            //     component: lazy(() => import('./views/report/ErrorReport'))
            // },
            // {
            //     title: 'users',
            //     exact: true,
            //     path: '/app/users',
            //     component: lazy(() => import('./views/createRoles/Roles'))
            // },
            // {
            //     title: 'shops',
            //     exact: true,
            //     path: '/app/shop',
            //     component: lazy(() => import('./views/addShop/Shop'))
            // },
            // {
            //     title: 'shopFiles',
            //     exact: true,
            //     path: '/app/shopFiles',
            //     component: lazy(() => import('./views/addShop/ShopFile'))
            // },
            // {
            //     title: 'routes',
            //     exact: true,
            //     path: '/app/routes',
            //     component: lazy(() => import('./views/Shops Assignments/MapFile'))
            // },
            // {
            //     title: 'shareDashBoard',
            //     exact: true,
            //     path: '/app/shareDashBoard',
            //     component: lazy(() => import('./views/shareReport/DashBoard'))
            // },
            // {
            //     title: 'mapQuestions',
            //     exact: true,
            //     path: '/app/mapQuestions',
            //     component: lazy(() => import('./views/mapQuestions/MapQuestion'))
            // },
            // {
            //     title: 'period',
            //     exact: true,
            //     path: '/app/period',
            //     component: lazy(() => import('./views/auditPeriod/AddPeriod'))
            // },
            // {
            //     title: 'task',
            //     exact: true,
            //     path: '/app/task',
            //     component: lazy(() => import('./views/AssignTask/Task'))
            // },

            // {
            //     exact: true,
            //     path: '/app/survey',
            //     component: lazy(() => import('./views/survey'))
            // },
            // // {
            // //     exact: true,
            // //     path: '/app/survey',
            // //     component: lazy(() => import('./views/'))
            // // },
            // // {
            // //     exact: true,
            // //     path: '/app/imageView',
            // //     component: lazy(() => import('./views/survey/ImageView'))
            // // },
            // {
            //     exact: true,
            //     path: '/app/productivityReports',
            //     component: lazy(() => import('./views/visitProductivityReports/ProductivityReports'))
            // },
            // {
            //     exact: true,
            //     path: '/app/copyPeriod',
            //     component: lazy(() => import('./views/copy Period/CopyPeriod'))
            // },
            // {
            //     exact: true,
            //     path: '/app/projectWithQuestionId',
            //     component: lazy(() => import('./views/flatQuestions/ProjectWithQuestionId'))
            // },
            // {
            //     exact: true,
            //     path: '/app/auditorShops',
            //     component: lazy(() => import('./views/Shops Assignments/AuditorShop'))
            // },
            // {
            //     exact: true,
            //     path: '/app/qcShops',
            //     component: lazy(() => import('./views/Shops Assignments/QcShop'))
            // },
            // {
            //     exact: true,
            //     path: '/app/shopFileData',
            //     component: lazy(() => import('./views/addShop/ShopFilesData'))
            // },
            // // {
            // //     exact: true,
            // //     path: '/app/dashboard',
            // //     component: lazy(() => import('./views/dashboard/DashDefault'))
            // // },
            // {
            //     exact: true,
            //     path: '/basic/button',
            //     component: lazy(() => import('./views/ui-elements/basic/BasicButton'))
            // },
            // {
            //     exact: true,
            //     path: '/basic/badges',
            //     component: lazy(() => import('./views/ui-elements/basic/BasicBadges'))
            // },
            // {
            //     exact: true,
            //     path: '/basic/breadcrumb',
            //     component: lazy(() => import('./views/ui-elements/basic/BasicBreadcrumb'))
            // },
            // {
            //     exact: true,
            //     path: '/basic/collapse',
            //     component: lazy(() => import('./views/ui-elements/basic/BasicCollapse'))
            // },
            // {
            //     exact: true,
            //     path: '/basic/tabs-pills',
            //     component: lazy(() => import('./views/ui-elements/basic/BasicTabsPills'))
            // },
            // {
            //     exact: true,
            //     path: '/basic/typography',
            //     component: lazy(() => import('./views/ui-elements/basic/BasicTypography'))
            // },

            // {
            //     exact: true,
            //     path: '/forms/form-basic',
            //     component: lazy(() => import('./views/forms/FormsElements'))
            // },
            // {
            //     exact: true,
            //     path: '/tables/bootstrap',
            //     component: lazy(() => import('./views/tables/BootstrapTable'))
            // },

            // {
            //     exact: true,
            //     path: '/charts/nvd3',
            //     component: lazy(() => import('./views/charts/nvd3-chart'))
            // },
            // {
            //     exact: true,
            //     path: '/maps/google-map',
            //     component: lazy(() => import('./views/maps/GoogleMaps'))
            // },
            // {
            //     exact: true,
            //     path: '/maps/leaflet-map',
            //     component: lazy(() => import('./views/survey/LeafletReactMap'))
            // },
            // {
            //     exact: true,
            //     path: '/sample-page',
            //     component: lazy(() => import('./views/extra/SamplePage'))
            // },
            {
                path: '*',
                exact: true,
                component: () => <Redirect to={BASE_URL} />
            }
        ]
    }
];

export default routes;
